import { Service } from './http-service';
import type { AdditionalCostsDto, RequestAdditionalCostsDto } from '@carvia/ros-client-types';

class PricingService extends Service {
  constructor() {
    super('/pricing');
  }

  async requestAdditionalCosts(params: RequestAdditionalCostsDto) {
    const res = await this.httpClient.post<AdditionalCostsDto>(
      `${this.endpoint}/additional-costs`,
      params,
    );
    return res.data;
  }
}

export const pricingService = new PricingService();
